var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CallView',{attrs:{"token":_vm.token,"is-recording":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }